import { render, staticRenderFns } from "./PrivilegePage.vue?vue&type=template&id=1b55171c&scoped=true&"
import script from "./PrivilegePage.vue?vue&type=script&lang=js&"
export * from "./PrivilegePage.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegePage.vue?vue&type=style&index=0&id=1b55171c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55171c",
  null
  
)

export default component.exports